import { render } from "./InfoReservation.vue?vue&type=template&id=562c28be&scoped=true&ts=true"
import script from "./InfoReservation.vue?vue&type=script&lang=ts"
export * from "./InfoReservation.vue?vue&type=script&lang=ts"

import "./InfoReservation.vue?vue&type=style&index=0&id=562c28be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c28be"]])

export default __exports__